module.exports = "./img/6381473f56aa23a31735aa4bae9f45a4.jpg";